import React, { useState, useRef, useEffect } from "react";
import Campanita from '../../assets/iconos/campanita.blanca.svg'
import CampanitaNoti from '../../assets/iconos/notifications/NotificacionNuevaROJA.svg';
import Historial from '../../assets/iconos/historial.png'
import BaseNotification from '../../assets/iconos/notifications/etiquetaNormal.png';
import ImportantNotification from '../../assets/iconos/notifications/etiquetaImportante.png';
import GlobalNotification from '../../assets/iconos/notifications/etiquetaGlobal.png';


import { getAllUnreadNotifications } from '../../Services/NotificationService.js';


function DropDownUser (props){
    const [open, setOpen] = useState(false);
    const [notifications, setNotifications] = useState([]);
    
    const menuRef = useRef();
    const imgRef = useRef();

    window.addEventListener("click", (e)=>{
        if(e.target !== menuRef.current && e.target !== imgRef.current){
            setOpen(false);
        }
    });

    const getNotificationData = async () => {
        let rsp = await getAllUnreadNotifications();

        if(rsp?.Error == false){
            if(rsp.Data.data.length > 0){
                setNotifications(rsp.Data.data);
            }
        }
    }


    useEffect(() => {
        getNotificationData();
    }, []);

    return(
        <div>
            <div className='profileMenu' 
            >
                    <a href="#"><img
                    onClick={() => {setOpen(!open);}}
                    ref={imgRef} 
                    src={notifications.length > 0 ? CampanitaNoti : Campanita} 
                    alt="Campanita" 
                    className={open ? "notif-icon-active" : 'icon'}/></a>        
            </div>
            {
                open &&(
                <div ref={menuRef}
                className='noti-menu-container'>
                <ul>
                    <div className="noti-title">
                        <h4>Ultimas Notificaciones</h4>
                    </div>
                    <div className="noti-content">
                        {
                            notifications.length > 0 ?
                            notifications.map(item => {
                                return(
                                    <div className="noti-container" key={item.id + 'ntf'} onClick={() => window.location.replace('?view=notificaciones&id_notification=' + item.id)}>
                                        <img src={item.id_notification_type === 1 ? GlobalNotification : item.id_notification_type == 2 ? BaseNotification : ImportantNotification} alt="noti-icon"  className="noti-icon"/>
                                        <a to="/cursada/1/revision"><div className="noti-content-text">
                                            <h6>{item.title}</h6>
                                            <p className="noti-desc">{item.created_at.split('T')[0]}<br/>{item.created_at.split('T')[1].split('.')[0]}</p>
                                        </div></a>
                                    </div>
                                )
                            })
                            
                            :

                            <div className="no-noti-msg">
                                <h4>No hay notificaciones sin leer.</h4>
                            </div>
                        }
                    </div>
                    <div className="noti-more">
                        <h5 onClick={e => {props.setActualFrame('notificaciones'); setNotifications([])}}>Ver Mas</h5>
                    </div>                 
                </ul>
            </div> 
            )}
            
        </div>
    );
}



export default DropDownUser